import { FC } from "react";
import { SearchForm } from "./components/SearchForm";
import SearchMobileLayout from "./layouts/Search.mobile";
import SearchWebLayout from "./layouts/Search.web";
import { FormProps } from "antd";
import { useTranslation } from "react-i18next";
import { SearchFormInputs } from "../../constants";
import { JourneyChip } from "..";
import Carrier from "@Components/Carrier/Carrier";

const MainSearch: FC<{initialValues?:SearchFormInputs} & FormProps> = ({initialValues, ...props}) => {
  return (
    <SearchForm
      render={({ errorFields }) => (
        <SearchWebLayout  errorFields={errorFields} />
      )}
      initialValues={initialValues}
      {...props} 
    />
  );
};

const MobileSearch: FC<{initialValues?:SearchFormInputs} & FormProps> = ({initialValues, ...props}) => {
  return (
    <SearchForm
      render={({errorFields }) => <SearchMobileLayout errorFields={errorFields} />}
      initialValues={initialValues}
      {...props}
    />
  );
};

const SecondarySearch: FC<{ initialValues:SearchFormInputs } & FormProps> = ({ initialValues, onFinish, ...props }) => {
  const { t } = useTranslation();

  return Carrier({
    label: t("Hotels.search.editSearch"),
    renderTrigger: ({ open }) => (
      <div className="cursor-pointer rounded-md border border-border-default p-3" onClick={open}>
        <JourneyChip searchObject={initialValues} />
      </div>
    ),
    renderSheet: ({ close }) => (
      <div className="overflow-y-auto">
        <MobileSearch
          initialValues={initialValues}
          onFinish={(values) => {
            close();
            onFinish?.(values);
          }}
          {...props}
        />
      </div>
    ),
  });
};

export { MainSearch, SecondarySearch, MobileSearch };
 